<template>
  <div style="display: flex">
    <div class="select-box-holder">
      <div class="selected-tag">
        <div
          style="display: flex; justify-content: space-between"
          v-if="selectedValue"
        >
          <div>
            <!-- TODO Here can we use the object itself in :tags so it has the extra custom and emoji props? -->
            <DisplayTagsVue
            :size="30"
            :tags="[
              formattedDataSource?.find(
                (item) => item.type === selectedValue
              ),
            ]"
            />
          </div>
        </div>
        <div class="select-tag selected-tag" v-else>Select&nbsp;tag....</div>
      </div>
      <DxSelectBox
        :value="{ type: selectedValue, desc: selectedValue }"
        width="400"
        height="46"
        :dataSource="formattedDataSource"
        :grouped="false"
        @value-changed="emitE"
        :disabled="disabled"
        placeholder=""
      >
        <template #item="{ data }">
          <DisplayTagsVue :tags="[data]" :size="30" />
        </template>
      </DxSelectBox>
    </div>
    <div class="deselect-tags" v-if="selectedValue" @click="removeTag">
      <i class="fa fa-times"></i>
    </div>
    <div class="placeholder" v-else></div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import DxSelectBox from "devextreme-vue/select-box";
import DisplayTagsVue from "../email/DisplayTags.vue";
// import func from "../../../../../../../vue-temp/vue-editor-bridge";

const props = defineProps({
  dataSource: Array,
  disabled: Boolean,
  selectedValue: String,
});

const emit = defineEmits(["selectedItem"]);

let formattedDataSource = ref([]);

function showExp(e) {
  return e.desc;
}

function removeTag() {
  emitE({ value: { type: "" } });
}

function emitE(e) {
  emit("selectedItem", e.value.type);
}
// onMounted(() => {
function processDataSource() {
  if (!props.dataSource) {
    console.error("DROP DOWN props.dataSource is not defined");
    return;
  }

  //const target = Reflect.get(props.dataSource, 'Target');
  //console.log('DROP DOWN Actual Target:', target);

  formattedDataSource.value = props.dataSource
    .slice() // Create a copy of the array
    .filter((el) => el.custom !== true) // Filter out elements with custom="true"
    .sort((a, b) => a.tag.localeCompare(b.tag)) // Sort by tag
    .map((el) => {
      return {
        type: el.tag,
        desc: el.tag,
        custom: el.custom,
        emoji: el.desc,
      };
    });
}

watch(
  () => props.dataSource,
  (newVal) => {
    if (newVal && newVal.length) {
      processDataSource();
    }
  },
  { immediate: true, deep: true }
);

emitE({ value: { type: props.selectedValue } });
</script>

<style lang="scss" scoped>
.placeholder {
  width: 1.75rem;
}

.select-box-holder {
  position: relative;
  // background-color: #ffffff !important;
}

.select-box-holder .dx-texteditor.dx-editor-filled {
  background-color: #ffffff !important;
}

.selected-tag {
  z-index: 2;
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
}
.select-tag {
  font-size: 1rem;
  top: 0.3rem;
}

.deselect-tags {
  color: red;
  font-size: 2rem;
  padding: 2px 0 0 2px;
  text-transform: bold;
  transform: translateY(3px);
}
</style>
